import React from 'react';
import Link from 'next/link';

const Alchemis_lab_item = ({
 data,
 classes = 'grid grid-cols-1 gap-12 gap-y-[100px] md:grid-cols-2',
}) => {
  return (
    <>
      <div className={classes}>
        {data.map((item) => {
          const { id, image, title, text, url } = item;
          return (
            <article key={id}>
              <div className="h-full rounded-t-[20px] overflow-hidden transition-shadow hover:shadow-lg">
                <figure className="group overflow-hidden">
                  <Link href={url}>
                    <img
                      src={image}
                      alt={title}
                      style={{height: 500}}
                      className="w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105 "
                    />
                  </Link>
                </figure>

                {/* <!-- Body --> */}
                <div style={{height: 'calc(100% - 500px)'}} className="pt-10 justify-between">
                  {/* <!-- Meta --> */}
                  <div className="mb-10">
                    <h2 className="font-display text-jacarta-700 mb-4 text-xl dark:text-white">
                      {title}
                    </h2>
                    <p className="dark:text-jacarta-200 text-base">{text}</p>
                  </div>
                  <Link href={url} className="text-accent hover:underline">
                    View More
                  </Link>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </>
  );
};

export default Alchemis_lab_item;
;
